import { Link } from "react-router-dom";

export function LogoMark({ size = 36, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="bsg" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="hsl(217 91% 60%)" />
          <stop offset="1" stopColor="hsl(189 94% 43%)" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#bsg)" opacity="0.14" />
      <rect x="2" y="2" width="60" height="60" rx="16" fill="none" stroke="url(#bsg)" strokeWidth="1.5" opacity="0.5" />
      <path
        d="M22 16h11c6.6 0 11 3.4 11 8.6 0 3.4-1.9 5.8-5 6.9 3.8.9 6.2 3.6 6.2 7.5 0 5.6-4.6 9-11.7 9H22V16zm10.4 12.4c2.6 0 4.2-1.3 4.2-3.5s-1.6-3.4-4.2-3.4h-4.1v6.9h4.1zm.7 12.8c2.8 0 4.5-1.4 4.5-3.7 0-2.3-1.7-3.6-4.6-3.6h-4.7v7.3h4.8z"
        fill="url(#bsg)"
      />
      <circle cx="47" cy="17" r="4.5" fill="hsl(160 84% 39%)" />
    </svg>
  );
}

export default function Logo({ to = "/", compact = false, className = "" }) {
  return (
    <Link to={to} className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark size={compact ? 32 : 38} />
      {!compact && (
        <span className="font-display text-lg font-extrabold tracking-tight leading-none">
          Buddy <span className="bs-gradient-text">Solution</span>
        </span>
      )}
    </Link>
  );
}
